import { Component, OnInit } from "@angular/core";
import { InvoiceCashDeskService } from "../../../services/invoice-cash-desk/invoice-cash-desk.service";
import { ActivatedRoute } from "@angular/router";
import { InvoiceManualCashDeskService } from "../../../services/invoice-cash-desk/invoice-manual-cash-desk.service";

@Component({
  selector: 'invoice-manual-cash-desk-view',
  templateUrl: './invoice-manual-cash-desk-view.component.html',
  providers: [{ provide: InvoiceCashDeskService, useClass: InvoiceManualCashDeskService }]
})
export class InvoiceManualCashDeskViewComponent implements OnInit {

  invoiceId: number;
  appointmentId?: number;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.params.subscribe(async params => {
      this.invoiceId = params['Id'];
      this.appointmentId = params['AppointmentId'];
    });
  }

  close(): void {
    history.back();
  }
}
